<template>
  <div>
    <v-menu
      offset-y
      full-width
      v-model="menu"
      :close-on-content-click="false"
      nudge-top="24"
    >
      <v-select
        :label="label"
        item-text="name"
        item-value="id"
        v-model="userIds"
        :items="users"
        :hide-selected="true"
        :multiple="multiple"
        :clearable="!multiple"
        append-icon="add"
        :append-icon-cb="onMenu"
        :hint="hint"
        persistent-hint="persistent-hint"
        slot="activator"
        content-class="hide-list"
        :rules="xRules.users"
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            close
            @input="onDelSeclect(data.item.id)"
            :selected="data.selected"
            class="chip--select-multi"
            :key="data.item.id"
            :color="data.item.userId? '':'blue lighten-4' "
            small
            v-if="multiple === true"
          >
            {{data.index + 1}}. {{ data.item.name }}
          </v-chip>
          <div v-else>{{ data.item.name }}</div>
        </template>
      </v-select>

      <v-card>
        <v-form v-model="formValid" ref="formRef">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs3>
                <v-select
                  label="本系统用户"
                  required
                  v-model="isEmployee"
                  :items="employeeTypes"
                  :rules="xRules.required"
                />
              </v-flex>
              <v-flex xs9 v-if="isEmployee === 'T'">
                <v-select
                  label="系统用户"
                  item-text="name"
                  item-value="dbid"
                  autocomplete
                  clearable
                  required
                  :rules="xRules.required"
                  :loading="candidateLoading"
                  :items="candidateItems"
                  :search-input.sync="candidateSearch"
                  v-model="candidate"
                  :return-object="true"
                  @keyup.enter="onCandidateSearch"
                  hint="输入关键词，按回车键检索，并选择系统内的用户。"
                  persistent-hint
                >
                  <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{data.item.name}}{{formatTitle(data.item.title)}}{{formatAge(data.item.birthday)}}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>{{formatDept(data.item.deptRoles)}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs9 v-else>
                <v-text-field
                  label="系统外人员"
                  required
                  :rules="xRules.required"
                  v-model="candidateName"
                  hint="输入外单位人员姓名，或系统外的人员。"
                  persistent-hint
                />
              </v-flex>
              <v-flex xs3>
                <v-select
                  v-if="multiple === true"
                  label="排序"
                  v-model="candidateRank"
                  :items="candidateRanks"
                  :multiple="false"
                  tags
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="onClose">关闭</v-btn>
          <v-btn color="primary" @click="onAddUser">添加</v-btn>
        </v-card-actions>

      </v-card>
    </v-menu>
  </div>
</template>
<script>
  export default {
    props: ['value', 'label', 'hint', 'persistent-hint', "rules", "multiple"],

    data() {
      return {
        userURI: '/api/syst/user/',

        menu: false,
        formValid: true,

        loading: false,

        id: 0,
        userIds: [],
        users: [],

        isEmployee: '',
        employeeTypes: [{text: '是', value: 'T'}, {text: '否', value: 'F'}],
        candidate: {},
        candidateName: '',
        candidateRank: 1,

        candidateSearch: '',
        candidateLoading: false,
        candidateItems: [],

        candidateRanks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],

        /**
         * 验证规则
         */
        xRules: {
          users: [v => ((Array.isArray(v) && v.length > 0) || v !== "") || '必填项。'],
          required: [
            v => (!this.menu || !!v) || '必填项。'
          ]
        }
      }
    },
    watch: {
      value(val) {
        window.console.log("in watch value");
        window.console.log(val);

        if (this.multiple === true) {
          if (Array.isArray(val)) {
            this.users = val;
            this.userIds = this.users.map(v => v.id);
            this.id = this.users.length;
          } else {
            this.users = [];
            this.userIds = [];
            this.id = 0;
          }
        } else {
          if (val == null) {
            this.users = [];
            this.userIds = "";
            this.id = 0;
          }
          else {
            this.users = [Object.assign(val, {"id": 0})];
            this.userIds = 0;
            this.id = 0;
          }
        }
      }
    },

    methods: {
      onMenu() {
        this.menu = !this.menu;
      },

      onCandidateSearch() {
        const vm = this;
        const param = window.xutil.param("name", this.candidateSearch);

        vm.candidateLoading = true;
        this.axios.get(vm.userURI, {params: param})
          .then(
            rsp => {
              vm.candidateLoading = false;
              vm.candidateItems = rsp.data.items
            })
      },

      onAddUser() {
        window.console.log("in onAddUser");
        if (this.$refs.formRef.validate()) {
          if (this.multiple === true) {
            if (this.isEmployee === 'T') {
              const it = {id: this.id, userId: this.candidate.dbid, name: this.candidate.name};
              this.users.push(it);
            } else {
              const it = {id: this.id, name: this.candidateName};
              this.users.push(it);
            }

            this.userIds.push(this.id);
            this.id += 1;

            this.isEmployee = 'T';
            this.candidate = {};
            this.candidateName = '';

            this.$refs.formRef.reset();

            this.$emit('input', this.users);
          } else {
            if (this.isEmployee === 'T') {
              let deptName = null;
              if (this.candidate.deptRoles && this.candidate.deptRoles.length > 0) {
                deptName = this.candidate.deptRoles[0].department.name;
              }
              const it = {id: this.id, userId: this.candidate.dbid, name: this.candidate.name, deptName: deptName};
              this.users = [it];
              this.userIds = it.id;
            } else {
              const it = {id: this.id, name: this.candidateName};
              this.users = [it];
              this.userIds = it.id;
            }

            this.id += 1;

            this.isEmployee = 'T';
            this.candidate = {};
            this.candidateName = '';

            this.$refs.formRef.reset();

            this.$emit('input', this.users.length > 0 ? this.users[0] : {});

            this.menu = false;
          }
        }
      },

      onDelSeclect(r) {
        window.console.log("in onDelSeclect " + r);
        const idx = this.userIds.findIndex(v => v === r);

        window.console.log("in onDelSeclect idx" + idx);
        this.userIds.splice(idx, 1);
        this.users.splice(idx, 1);

        this.$emit('input', this.users);
      },

      onClose() {
        this.menu = false;
      },

      formatAge(birthday) {
        let age = null;
        if (birthday) {
          age = new Date(new Date() - new Date(birthday)).getFullYear() - 1970;
        }
        return age ? ` / ${age}岁` : '';
      },

      formatTitle(title) {
        return title ? ` / ${title.name}` : '';
      },

      formatDept(deptRoles) {
        return (deptRoles || []).map(dr => dr.department.name).unique().join(", ");
      }
    }

  }
</script>
<style>
  div.menu__content.hide-list {
    display: none;
  }
</style>

